import {FC} from 'react';
import {
	getMyTaxSuccessDescription,
	getMyTaxSuccessIcon,
	getMyTaxSuccessTitle,
	RegistrationWorkStatus,
} from '../../model';
import {StepLayout} from 'features/registration';
import styles from './MyTaxSuccessStep.module.css';

type Props = {
	workStatus: RegistrationWorkStatus | null;
};

export const MyTaxSuccessStep: FC<Props> = ({workStatus}) => {
	const Illustration = getMyTaxSuccessIcon(workStatus);

	return (
		<StepLayout variant="fill" className={styles.root}>
			<StepLayout.Intro
				title={getMyTaxSuccessTitle()}
				subtitle={getMyTaxSuccessDescription(workStatus)}
			/>

			<StepLayout.Content className={styles.illustration}>
				<Illustration className={styles.illustrationIcon} />
			</StepLayout.Content>
		</StepLayout>
	);
};
